/** * * Asynchronously loads the component for
Returning Signin
* */ import { lazyLoad } from "utils/loadable";
export const ReturningSignin = lazyLoad(
  () => import("./index"),
  (module) => module.ReturningSignin
);